import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductCardSliderComponent } from '@shared';
import { mapProductDetailsDtoToInternal, ProductDetails, SectionDTO, SortBy } from '@models';
import { MatButtonModule } from '@angular/material/button';
import { SkeletonTemplateService } from '@skeleton-loader';
import { catchError, EMPTY, finalize, map, tap } from 'rxjs';
import { BreakpointObserverService, NavigationService, PRODUCTS_PER_PAGE, ProductService } from '@core';

@Component({
  selector: 'app-section-products',
  imports: [CommonModule, ProductCardSliderComponent, MatButtonModule],
  templateUrl: './section-products-slider.component.html',
  styleUrls: ['./section-products-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ProductService],
})
export class SectionProductsSliderComponent {
  section = input<SectionDTO | null>(null);
  skeletonService = inject(SkeletonTemplateService);
  private productService = inject(ProductService);
  navigationService = inject(NavigationService);
  isMobile = inject(BreakpointObserverService).isMobile;

  products = signal<ProductDetails[]>([]);
  isLoading = signal<boolean>(true);

  onAction(): void {
    this.navigationService.goToCategoryPage(this.section().categoryId);
  }

  private loadProducts(): void {
    if (this.section() && this.section().categoryId) {
      const { categoryId } = this.section();
      this.isLoading.set(true);
      this.productService
        .getProducts({ categoryIds: [categoryId], count: PRODUCTS_PER_PAGE, offset: 0, sortBy: SortBy.Random })
        .pipe(
          map(({ items }) => items.map(mapProductDetailsDtoToInternal)),
          tap((items) => this.products.set(items)),
          catchError(() => EMPTY),
          finalize(() => this.isLoading.set(false)),
        )
        .subscribe();
    }
  }

  ngOnInit(): void {
    this.loadProducts();
  }
}
